<template>
  <div class="row">
    <div class="col-lg-12 text-left">
      <input
        type="checkbox"
        :id="`addSalaryExpectation-${index}`"
        v-model="choices.hasExpectation"
      />
      <label :for="`addSalaryExpectation-${index}`"
        >Deseja adicionar um valor esperado?</label
      >
    </div>
    <div v-if="choices.hasExpectation" class="col-lg-12">
      <div class="row">
        <div class="col-lg-5">
          <currency-input
            v-model="choices.expectedSalary.minValue"
            class="form-control"
            placeholder="0,00"
          />
        </div>
        <div class="col-lg-2" v-if="choices.salaryRange">
          <div class="d-table h-100 w-100">
            <span class="d-table-cell align-bottom">Até</span>
          </div>
        </div>
        <div class="col-lg-5" v-if="choices.salaryRange">
          <currency-input
            v-model="choices.expectedSalary.maxValue"
            class="form-control"
            placeholder="0,00"
          />
        </div>
        <div class="col-lg-7">
          <button
            class="btn btn-primary full"
            :class="{ 'mt-2': choices.salaryRange }"
            @click="choices.salaryRange = !choices.salaryRange"
          >
            {{
              choices.salaryRange
                ? "Cadastrar valor fixo"
                : "Cadastrar faixa de valores"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "index"],
  data: () => ({
    choices: {
      hasExpectation: false,
      salaryRange: false,
      expectedSalary: {
        minValue: 0,
        maxValue: 0,
      },
    },
  }),
  mounted() {
    if (this.value && Object.keys(this.value).length > 0)
      this.choices = this.value;
  },
  watch: {
    choices: {
      handler: function () {
        this.updateOptions();
      },
      deep: true,
    },
  },
  methods: {
    updateOptions() {
      this.$emit("input", this.choices);
      eventBus.$emit("updateQuestions", []);
    },
  },
};
</script>